// CouponListContainer.jsx
import React, { useEffect, useState, useMemo } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../HandleAPICalls/actions";
import CouponListComponent from "./component";

const CouponListContainer = (props) => {
  const [activatedCoupons, setActivatedCoupons] = useState([]);
  const [deactivatedCoupons, setDeactivatedCoupons] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [query, setQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('All');

  const dismissError = () => {
    setError(null);
  };

  useEffect(() => {
    setLoading(true);
    setError(null);
    
    props.getDataFromAPI(
      "/partner/api/v1/coupon/fetchAll",
      "GET",
      undefined,
      (response) => {
        setActivatedCoupons(response.activatedCoupons || []);
        setDeactivatedCoupons(response.deactivatedCoupons || []);
        setLoading(false);
      },
      (error) => {
        setError("Failed to fetch coupons. Please try again.");
        setLoading(false);
      }
    );
  }, [props]);

  const allCoupons = useMemo(() => [
    ...activatedCoupons.map(c => ({ ...c, status: 'Activated' })),
    ...deactivatedCoupons.map(c => ({ ...c, status: 'Deactivated' }))
  ], [activatedCoupons, deactivatedCoupons]);

  const filtered = useMemo(() => {
    const search = query.trim().toLowerCase();

    let baseList = [];

    if (statusFilter === 'Activated') {
      baseList = activatedCoupons.map(c => ({ ...c, status: 'Activated' }));
    } else if (statusFilter === 'Deactivated') {
      baseList = deactivatedCoupons.map(c => ({ ...c, status: 'Deactivated' }));
    } else {
      baseList = allCoupons;
    }

    if (!search) return baseList;

    return baseList.filter(c =>
      (c.couponName && c.couponName.toLowerCase().includes(search)) ||
      (c.couponId && c.couponId.toString().includes(search))
    );
  }, [query, allCoupons, activatedCoupons, deactivatedCoupons, statusFilter]);

  return (
    <CouponListComponent
      loading={loading}
      error={error}
      filtered={filtered}
      query={query}
      setQuery={setQuery}
      statusFilter={statusFilter}
      setStatusFilter={setStatusFilter}
      onDismissError={dismissError}
    />
  );
};

function mapStateToProps(state) {
  return {
    // Add redux state here if needed
  };
}

export default connect(mapStateToProps, {
  getDataFromAPI,
})(CouponListContainer);